import { updateFundPermissions } from 'store/reducers-common/Auth/slice'
import { updatePoolStatus } from 'store/reducers-common/Fund/slice'
import { setCurrentFundStatus } from 'store/reducers-common/Funds/slice'
import {
  addDepositAssetsChangesData,
  addDepositWithdrawalAsset,
  addFee,
  addInvestorTransactions,
  addSwapTransactions,
  addTransactions,
  addWithdrawalAssetsChangesData,
  setAssetAllocationUpdated,
  setAssetAllocationUpdatedNoAum,
  setPoolStatus,
  shiftDepositPendingTimestamp,
  updateDepositAssetsChangesData,
  updateDepositWithdrawalAssetData,
  updateWithdrawalAssetsChangesData,
} from 'store/reducers-common/Pool/slice'
import { setQuote, setSwap } from 'store/reducers-fund/Protocol/slice'

export const events = {
  AssetAllocationEvent: [setAssetAllocationUpdatedNoAum],
  DepositClaimedEvent: [updateDepositAssetsChangesData, updateDepositWithdrawalAssetData],
  DepositEvent: [addTransactions, addInvestorTransactions, setAssetAllocationUpdated, shiftDepositPendingTimestamp],
  DepositRequestExecutedEvent: [updateDepositAssetsChangesData, updateDepositWithdrawalAssetData],
  DepositRequestReceivedEvent: [addDepositWithdrawalAsset, addDepositAssetsChangesData],
  FeeAccruedEvent: [addFee],
  FundStatusChangedEvent: [setCurrentFundStatus],
  OneInchQuoteEvent: [setQuote],
  OneInchSwapEvent: [setSwap],
  PermissionsUpdatedEvent: [updateFundPermissions],
  PoolCreatedEvent: [updatePoolStatus],
  PoolStatusChangedEvent: [setPoolStatus],
  RedeemClaimedEvent: [updateWithdrawalAssetsChangesData, updateDepositWithdrawalAssetData],
  SuccessfullControllerCallEvent: [addSwapTransactions],
  WithdrawEvent: [addTransactions, addInvestorTransactions, setAssetAllocationUpdated],
  WithdrawRequestExecutedEvent: [updateWithdrawalAssetsChangesData, updateDepositWithdrawalAssetData],
  WithdrawRequestReceivedEvent: [addDepositWithdrawalAsset, addWithdrawalAssetsChangesData],
}
